import styles from 'typescript/components/page_loader.module.scss';
import { MarketActivityIndicator } from '@market/react';
import { HTMLAttributes, CSSProperties } from 'react';

export const ROOT_TEST_ID = 'root-test-id';
export const PAGE_LOADER_TEST_ID = 'page-loader-test-id';

export type PageLoaderProps = HTMLAttributes<HTMLElement> & {
  delayMs?: number;
  indicatorSize?: HTMLMarketActivityIndicatorElement['size'];
};

const PageLoader = ({
  delayMs = 0,
  indicatorSize,
  className,
}: PageLoaderProps) => {
  return (
    <div
      // we can use the style prop to pass a custom CSS property to be read by
      // the css we set in the module.scss file
      style={
        {
          '--delayMs': `${delayMs}ms`,
          '--opacity': `${delayMs ? 0 : 1}`,
        } as CSSProperties
      }
      className={styles.root}
      data-testid={ROOT_TEST_ID}
    >
      <MarketActivityIndicator
        data-testid={PAGE_LOADER_TEST_ID}
        {...(className && { className })} // pass in className if you want to override the default styles
        {...(indicatorSize && { size: indicatorSize })}
      />
    </div>
  );
};

export default PageLoader;
